module.exports = __webpack_public_path__ + "static/media/fondo_slider.3bf87d5a.webp";